import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({name: "html"})
export class HtmlPipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {
    }

    transform(value) {
        return value ? this.domSanitizer.bypassSecurityTrustHtml(value) : "";
    }
}



// WEBPACK FOOTER //
// ./src/app/html-utils/html.pipe.ts